module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (positions.length === 1) { ;
__p += '\n\n  <div class="featured-position">\n    ';
 if (positions[0].logo_url) { ;
__p += '\n      <div style="background-image: url(' +
__e( positions[0].logo_url ) +
');" class="company-logo"></div>\n    ';
 } ;
__p += '\n\n    <h4>' +
__e( positions[0].title ) +
'</h4>\n    <p class="small">\n      ';
 if (positions[0].city) { ;
__p += '\n        ' +
__e( positions[0].company_name ) +
' - ' +
__e( positions[0].city ) +
'<br />\n        $' +
__e( positions[0].wage ) +
'/hour\n      ';
 } else { ;
__p += '\n        ' +
__e( positions[0].company_name ) +
' - $' +
__e( positions[0].wage ) +
'/hour\n      ';
 } ;
__p += '\n    </p>\n  </div>\n\n  <div class="actions">\n    <div class="loader-container">\n      <button class="btn btn-large btn-primary intro-end">\n        Start application\n      </button>\n      <div class="loader">Loading...</div>\n    </div>\n    <p>\n      Since you\'ve applied on WorkStep before, you\'re already\n      <strong class="highlight">90% done!</strong>\n    </p>\n  </div>\n\n\n';
 } else { ;
__p += '\n\n  <h2>\n    You\'re interested in\n      <strong>\n        ' +
__e( positions.length ) +
'\n        job' +
__e( positions.length > 1 ? 's' : '' ) +
'!\n      </strong>\n  </h2>\n\n  ';
 _.each(positions, function(p){ ;
__p += '\n    <p class="selected-position">\n      ' +
__e( p.title ) +
'\n      <span class="subtitle">\n        ' +
__e( p.company_name ) +
' - ' +
__e( p.location_name ) +
'\n      </span>\n    </p>\n  ';
 }); ;
__p += '\n\n  <div class="actions">\n    ';
 if (!complete) { ;
__p += '\n      <p>\n        <strong>\n          Apply ' +
__e( positions.length > 1 ? 'to these ' : '' ) +
'now?\n        </strong>\n      </p>\n\n      <p class="highlight">\n        Estimated completion time: <strong>6 minutes</strong>\n      </p>\n    ';
 } ;
__p += '\n\n    <div class="loader-container">\n      <button class="btn btn-large btn-primary intro-end">\n        Start application\n      </button>\n      <div class="loader">Loading...</div>\n    </div>\n\n    ';
 if (complete) { ;
__p += '\n      <p>\n        Since you\'ve applied on WorkStep before, you\'re already\n        <strong class="highlight">90% done!</strong>\n      </p>\n    ';
 } ;
__p += '\n\n  </div>\n\n';
 } ;
__p += '\n';

}
return __p
}